<template>
  <!-- This component renders nothing. Its only job is to manage styles. -->
  <div v-if="styleElement" style="display: none;"></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ThemeManager',
  data() {
    return {
      styleElement: null, // To hold a reference to our <style> tag
    };
  },
  computed: {
    ...mapState(['clientDetails']),
    brandColour() { // Use British spelling
      return this.clientDetails?.brandColour;
    }
  },
  watch: {
    brandColour: { // Watch the correctly spelled property
      handler(newColour) {
        this.applyTheme(newColour);
      },
      immediate: true,
    },
  },
  methods: {
    applyTheme(colour) {
      // --- START: DEFINITIVE THEME LOGIC FIX ---
      const defaultYellow = '#FED803'; // The new Castive brand default
      const defaultSecondary = this.shadeColor(defaultYellow, -20); // Pre-calculate default secondary

      // If a valid colour is provided by the client, use it. Otherwise, fall back to the new default.
      const primaryColour = colour && colour.startsWith('#') ? colour : defaultYellow;
      const secondaryColour = colour && colour.startsWith('#') ? this.shadeColor(colour, -20) : defaultSecondary;
      // --- END: DEFINITIVE THEME LOGIC FIX ---

      const css = `
        :root {
          --color-brand-primary: ${primaryColour};
          --color-brand-secondary: ${secondaryColour};
        }
      `;

      if (!this.styleElement) {
        this.styleElement = document.createElement('style');
        this.styleElement.id = 'dynamic-theme-styles';
        document.head.appendChild(this.styleElement);
      }
      
      this.styleElement.innerHTML = css;
    },
    shadeColor(color, percent) {
      let R = parseInt(color.substring(1, 3), 16);
      let G = parseInt(color.substring(3, 5), 16);
      let B = parseInt(color.substring(5, 7), 16);

      R = parseInt(R * (100 + percent) / 100);
      G = parseInt(G * (100 + percent) / 100);
      B = parseInt(B * (100 + percent) / 100);

      R = (R < 255) ? R : 255;
      G = (G < 255) ? G : 255;
      B = (B < 255) ? B : 255;

      const RR = ((R.toString(16).length === 1) ? `0${R.toString(16)}` : R.toString(16));
      const GG = ((G.toString(16).length === 1) ? `0${G.toString(16)}` : G.toString(16));
      const BB = ((B.toString(16).length === 1) ? `0${B.toString(16)}` : B.toString(16));

      return `#${RR}${GG}${BB}`;
    }
  },
  beforeUnmount() {
    if (this.styleElement) {
      this.styleElement.remove();
    }
  }
};
</script>